import {configureStore, type ThunkAction, type Action} from "@reduxjs/toolkit";
import {addReducer} from "../components/configuration/add/addSlice";
import {editReducer} from "../components/configuration/edit/editSlice";
import {listReducer} from "../components/configuration/list/listSlice";
import {userMessages} from "../components/message-panel/user-messages-middleware";
import {messagesReducer} from "../components/message-panel/messagesSlice";
import {versionReducer} from "../components/version/versionSlice";
import {accountReducer} from "../components/layout/accountSlice";

export const store = configureStore({
  reducer: {
    messages: messagesReducer,
    list: listReducer,
    add: addReducer,
    edit: editReducer,
    version: versionReducer,
    account: accountReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(userMessages)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
